import { render, staticRenderFns } from "./HeaderBlock.vue?vue&type=template&id=b874c258&scoped=true&"
import script from "./HeaderBlock.vue?vue&type=script&lang=js&"
export * from "./HeaderBlock.vue?vue&type=script&lang=js&"
import style0 from "./HeaderBlock.vue?vue&type=style&index=0&id=b874c258&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b874c258",
  null
  
)

export default component.exports